"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostcodeLocationWrapper$ = exports.PostcodeLocationWrapper$outboundSchema = exports.PostcodeLocationWrapper$inboundSchema = void 0;
exports.postcodeLocationWrapperToJSON = postcodeLocationWrapperToJSON;
exports.postcodeLocationWrapperFromJSON = postcodeLocationWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const postcodelocationattributes_js_1 = require("./postcodelocationattributes.js");
/** @internal */
exports.PostcodeLocationWrapper$inboundSchema = z.object({
    attributes: postcodelocationattributes_js_1.PostcodeLocationAttributes$inboundSchema,
    id: z.string(),
    type: z.literal("postcode").default("postcode").optional(),
});
/** @internal */
exports.PostcodeLocationWrapper$outboundSchema = z.object({
    attributes: postcodelocationattributes_js_1.PostcodeLocationAttributes$outboundSchema,
    id: z.string(),
    type: z.literal("postcode").default("postcode"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostcodeLocationWrapper$;
(function (PostcodeLocationWrapper$) {
    /** @deprecated use `PostcodeLocationWrapper$inboundSchema` instead. */
    PostcodeLocationWrapper$.inboundSchema = exports.PostcodeLocationWrapper$inboundSchema;
    /** @deprecated use `PostcodeLocationWrapper$outboundSchema` instead. */
    PostcodeLocationWrapper$.outboundSchema = exports.PostcodeLocationWrapper$outboundSchema;
})(PostcodeLocationWrapper$ || (exports.PostcodeLocationWrapper$ = PostcodeLocationWrapper$ = {}));
function postcodeLocationWrapperToJSON(postcodeLocationWrapper) {
    return JSON.stringify(exports.PostcodeLocationWrapper$outboundSchema.parse(postcodeLocationWrapper));
}
function postcodeLocationWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostcodeLocationWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostcodeLocationWrapper' from JSON`);
}
//# sourceMappingURL=postcodelocationwrapper.js.map